import { PropTypes } from 'prop-types';

export const metaDataPropType = PropTypes.exact({
  description: PropTypes.string,
  sitetitle: PropTypes.string,
});

export const sxPropType = PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.func]);
